import {
  dashboardSlice,
  getDonorComposite,
  getMailByState,
  getMailInsights,
  getMailPerformance,
  getTopClientMailing,
} from './slice';

export const Actions = {
  ...dashboardSlice.actions,
  getDonorComposite,
  getMailByState,
  getMailInsights,
  getMailPerformance,
  getTopClientMailing,
};
